import LoadingSpinner from '@atoms/LoadingSpinner/LoadingSpinner';
import { ISearchBlock } from '@models/ISearchBlock';
import SearchBar from '@molecules/SearchBar/SearchBar';
import SearchSummaryResults from '@molecules/SearchSummaryResults/SearchSummaryResults';
import useSearchSummaryResults from '@utils/hooks/useSearchSummaryResults';
import { useEffect, useState } from 'react';

const SearchBlock = ({
  searchSummaryPageLink,
  searchSummary,
  resultsFoundLabel,
  searchSubTitle,
  searchPlaceholder,
  overlaySearchIcon,
  statusLabels,
}: ISearchBlock) => {
  const [value, setValue] = useState('');
  const { isLoading, searchSummaryResults, fetchSearchSummaryResults } =
    useSearchSummaryResults(searchSummary, true);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const query = params.get('query');
    const decodedQuery = query ? decodeURI(query) : '';
    setValue(decodedQuery);
    fetchSearchSummaryResults(decodedQuery);
  }, [fetchSearchSummaryResults]);

  return (
    <>
      <div className="bg-grey-200">
        <div className="container relative z-70 pt-9 pb-10 lg:pt-44 lg:pb-44">
          <SearchBar
            searchSubTitle={searchSubTitle}
            searchPlaceholder={searchPlaceholder}
            overlaySearchIcon={overlaySearchIcon}
            listingPage={searchSummaryPageLink}
            value={value}
            setValue={setValue}
          />
        </div>
      </div>

      <div>
        {isLoading ? (
          <LoadingSpinner extraClasses="min-h-[400px]" />
        ) : (
          <SearchSummaryResults
            searchSummaryResults={searchSummaryResults}
            searchValue={value}
            productsStatusLabels={statusLabels}
            resultsFoundLabel={resultsFoundLabel}
          />
        )}
      </div>
    </>
  );
};

export default SearchBlock;
